"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jquery_1 = __importDefault(require("jquery"));
function initCollapsibleBlocks() {
    // eslint-disable-next-line func-names
    jquery_1["default"]('.object.collapsible').each(function () {
        var $target = jquery_1["default"](this);
        var $content = $target.find('.object-layout');
        var onAnimationComplete = function () {
            return $content
                .get(0)
                .dispatchEvent(new CustomEvent('commentAnchorVisibilityChange', { bubbles: true }));
        };
        if ($target.hasClass('collapsed') && $target.find('.error-message').length === 0) {
            $content.hide({
                complete: onAnimationComplete,
            });
        }
        $target.find('> .title-wrapper').on('click', function () {
            if (!$target.hasClass('collapsed')) {
                $target.addClass('collapsed');
                $content.hide({
                    duration: 'slow',
                    complete: onAnimationComplete,
                });
            }
            else {
                $target.removeClass('collapsed');
                $content.show({
                    duration: 'slow',
                    complete: onAnimationComplete,
                });
            }
        });
    });
}
window.initCollapsibleBlocks = initCollapsibleBlocks;
jquery_1["default"](function () {
    initCollapsibleBlocks();
});
